import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Button } from '@mui/material';

interface ValidationErrorDialogProps {
    open: boolean;
    message: string;
    title?: string;
    onClose: () => void;
}

const buttonSx = {
    borderColor: '#9588e8',
    color: '#9588e8',
    '&:hover': {
        borderColor: '#9588e8',
        backgroundColor: 'rgba(149, 136, 232, 0.08)',
    },
};

export const ValidationErrorDialog: React.FC<ValidationErrorDialogProps> = ({
    open,
    message,
    title = 'Ошибка',
    onClose,
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ textAlign: 'center' }}>{title}</DialogTitle>
            <DialogContent sx={{ overflow: 'visible', py: 2 }}>
                <Typography component="div" variant="body2" sx={{ textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: message }} />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
                <Button onClick={onClose} variant="outlined" sx={buttonSx}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
};
